import { call, put, takeLatest } from "redux-saga/effects";
import request from "@util/net/request";
import axios, { AxiosResponse } from "axios";
import qs from "qs";
import {
  GET_STYLING_STYLEHINT_LARGE_IMAGE_LIST,
  GET_STYLING_STYLEHINT_LIST,
  StylehintListActions,
  StylingFilterActions
} from "@redux/reducer";
import {
  FiltersResponseType,
  LargeStylehintStylingPayload,
  LargeStylehintStylingUgcPayload,
  LargeStylehintStylingUgcResponse,
  STYLING_SORT_BY,
  StylehintListPayload,
  StylehintListUgcPayload,
  StylehintListUgcResponse
} from "@type/index";
import {
  HashtagFilterMapper,
  HashtagLargeImgMapper,
  StylehintLargeQuery,
  StylehintNormalQuery
} from "@util/net/queryParameters";

export function* loadStylehintListSaga(action: {
  payload: StylehintListPayload;
}) {
  try {
    const payload: StylehintListPayload = action.payload;
    const _payload: StylehintListUgcPayload = StylehintNormalQuery(payload);
    if (_payload.order === STYLING_SORT_BY.PUBLISHED_AT_DESC) {
      _payload.priority_flag = true;
    }
    yield put(StylehintListActions.setStylehintListErrorCode(""));
    yield put(StylehintListActions.getStylingStylehintListLoading(true));
    const res: AxiosResponse<StylehintListUgcResponse> = yield call(
      request.get,
      "/contents/search",
      {
        params: { ..._payload },
        paramsSerializer: function (params: StylehintListUgcPayload) {
          return qs.stringify(params, { arrayFormat: "indices" });
        }
      }
    );
    if (res.status !== 200) {
      yield put(StylehintListActions.setStylehintListErrorCode("503"));
    } else {
      yield put(StylehintListActions.getStylingStylehintListSuccess(res.data));
    }
  } catch (error) {
    if (!axios.isCancel(error)) {
      yield put(StylehintListActions.setStylehintListErrorCode("503"));
    }
  }
}

export function* loadStylehintLargeListSaga(action: {
  payload: LargeStylehintStylingPayload;
}) {
  try {
    const payload: LargeStylehintStylingPayload = action.payload;
    const _payload: LargeStylehintStylingUgcPayload =
      StylehintLargeQuery(payload);
    yield put(StylehintListActions.getStylehintLargeImageListLoading(true));
    const res: AxiosResponse<LargeStylehintStylingUgcResponse> = yield call(
      request.get,
      "/suggest-hashtag/list",
      {
        params: { ..._payload },
        paramsSerializer: function (params: StylehintListUgcPayload) {
          return qs.stringify(params, { arrayFormat: "indices" });
        }
      }
    );
    yield put(
      StylehintListActions.getStylehintLargeImageListSuccess(
        HashtagLargeImgMapper(res.data.hashtags)
      )
    );
    const _res: FiltersResponseType = {
      hashtags:
        res.data.hashtags.length > 0
          ? [...HashtagFilterMapper(res.data.hashtags)]
          : []
    };
    yield put(StylingFilterActions.getStylingFiltersSuccess(_res));
  } catch (error) {
    yield put(StylehintListActions.getStylehintLargeImageListLoading(false));
  }
}

export function* watchLoadStylingListSaga() {
  yield takeLatest<any>(GET_STYLING_STYLEHINT_LIST, loadStylehintListSaga);
  yield takeLatest<any>(
    GET_STYLING_STYLEHINT_LARGE_IMAGE_LIST,
    loadStylehintLargeListSaga
  );
}
